import { render, staticRenderFns } from "./createShareMobile.vue?vue&type=template&id=1325525e&scoped=true"
import script from "./createShareMobile.vue?vue&type=script&lang=js"
export * from "./createShareMobile.vue?vue&type=script&lang=js"
import style0 from "./createShareMobile.vue?vue&type=style&index=0&id=1325525e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1325525e",
  null
  
)

export default component.exports